export const fontPrimary = '"Poppins", monospace';
export const fontSecondary = '"Poppins", monospace';
export const fontTertiary = '"Roboto Mono", monospace';
